import React, { FC } from 'react'
import { Switch, Route } from 'react-router-dom'

import * as routes from '../../constants/routes'
import { ModalHint } from '../../components/Typography'

import EmailInput from './EmailInput'
import Login from './Login'
import { MagicLink } from './MagicLink'
import { NavBar } from './NavBar'
import { Wrap, FooterWrap } from './styled'

const LogIn: FC = () => {
  return (
    <Wrap>
      <NavBar />
      <Switch>
        <Route exact path={routes.EMAIL_LOGIN} component={EmailInput} />
        <Route path={routes.MAGIC_LINK} component={MagicLink} />
        <Route path={routes.LOGIN} component={Login} />
      </Switch>
      <FooterWrap>
        <ModalHint>
          By continuing, you’re confirming that you’ve read and agree to our{' '}
          <span>Terms and Conditions</span>
          <br />
          <span>Privacy Policy</span> and <span>Cookie Policy</span>
        </ModalHint>
      </FooterWrap>
    </Wrap>
  )
}

export default LogIn
